<div class="cs-d-flex flex-column h-100">
    <div class="cs-flex-1 cs-common-ui--container overflow-hidden">
        <div class="cs-d-flex cs-d-flex-wrap h-100 w-100">
            <app-diagram-view2
                [nodes]="nodes"
                [nodeOptions]="nodeOptions"
                [screenName]="screenName"
                [settingsTypeId]="settingsTypeId"
                [dagSourceData]="workflowData?.dagSource"
                (hasUpdatedNode)="onUpdatedNode($event)"
                direction="vertical">
            </app-diagram-view2>
        </div>
    </div>
    <div class="cs-common-ui--cs-step-actions">
        <div class="cs-actions cs-d-flex h-100">
            <button (click)="goBack()" class="btn btn-link ml-auto">
                <span>Back</span>
            </button>
            <button class="btn btn-primary save_btn" (click)="goToNext()" [disabled]="!isValid">
                <span>Save</span>
            </button>
        </div>
    </div>
</div>

<app-common-modal-popups
    *ngIf="statusActivationConfirmation?.showModal"
    [modalConfig]="statusActivationConfirmation"
    (onCloseModal)="onCloseConfirmation($event,'activate')">
</app-common-modal-popups>

<app-common-modal-popups [modalConfig]="warningModalConfig" (onCloseModal)="onCloseConfirmation($event,'warning')"></app-common-modal-popups>
